import { GridRowHeightParams } from '@/global/components/DataGrid/utils/types'
import { LogCalculos } from '@/service/api'
import { match, P } from 'ts-pattern'

export function getDigitacaoRowHeight({ row, density }: GridRowHeightParams) {
    const densityFactor = match(density)
        .with('compact', () => 0.75)
        .with('comfortable', () => 1.25)
        .otherwise(() => 1)

    return match<number>(row.registros.length)
        .with(P.number.between(17, 24), () => 208 * densityFactor + 10)
        .with(P.number.between(11, 16), () => 156 * densityFactor + 10)
        .with(P.number.between(5, 10), () => 104 * densityFactor + 10)
        .otherwise(() => 52 * densityFactor + 10)
}

export function getDigitacaoRowClassName({ row }: { row: any }) {
    if (row.logs?.length) {
        if (row.logs.some((log: LogCalculos) => log.variante === 'error'))
            return 'bg-error/25 hover:bg-error/35' as const
        if (row.logs.some((log: LogCalculos) => log.variante === 'warning'))
            return 'bg-warning/25 hover:bg-warning/35' as const
        if (row.logs.some((log: LogCalculos) => log.variante === 'info'))
            return 'bg-info/25 hover:bg-info/35' as const
        if (row.logs.some((log: LogCalculos) => log.variante === 'success'))
            return 'bg-success/25 hover:bg-success/35' as const
    } else if (row.feriado) return 'bg-info/25 hover:bg-info/35' as const
    return ''
}
